module.exports = __webpack_public_path__ + "static/credit-4939ef0da2e3ca5712b43a89da3ac759.jpg";